<template>
  <base-table-box>
    <base-table
      class="custom-table"
      :columns="columns"
      :dataSource="tableData"
      :pagination="page"
      :rowKey="record => record.companyIntoId"
      :loading="loading"
      @change="handleTableChange"
    >
      <template #companyName="record">
        <a
          href="javascript: void 0;"
          class="text-btn"
          @click="$router.push(`${$route.path}/detail/${record.companyId}`)"
        >{{record.companyName}}</a>
      </template>
      <template #useHouseName="useHouseName">
        <a-tooltip :title="useHouseName">
          <div class="table-ellipsis">{{useHouseName}}</div>
        </a-tooltip>
      </template>
      <template #remark="remark">
        <a-tooltip :title="remark">
          <div class="table-ellipsis">{{remark}}</div>
        </a-tooltip>
      </template>
      <template #operation="record">
        <a v-if="record.state !== '6'&&record.state !== '2'"  href="javascript: void 0;" class="text-btn" @click="$router.push(`/investment/company-archives/change/${record.companyIntoId}`)">变更</a>
        <a v-if="record.state === '4'||record.state === '5'" href="javascript: void 0;" class="text-btn" @click="$router.push(`/investment/retreat/retreat/${record.companyIntoId}`)">办理退驻</a>
      </template>
    </base-table>
  </base-table-box>
</template>

<script>
import { investment } from '@/api'

export default {
  name: 'PageCompanyArchives',

  data () {
    return {
      columns: [
        {
          title: '合同编号',
          dataIndex: 'contractNo'
        },
        {
          title: '租赁日期',
          customRender: value =>
            value.beginDate && value.endDate
              ? `${value.beginDate}~${value.endDate}`
              : ''
        },
        {
          title: '承租方',
          dataIndex: 'companyName'
        },
        {
          title: '租赁房屋',
          dataIndex: 'intoNames'
        },
        {
          title: '总面积',
          dataIndex: 'totalArea'
        },
        {
          title: '应缴面积',
          dataIndex: 'dismissArea'
        },
        {
          title: '租金',
          dataIndex: 'rentPay'
        },
        {
          title: '保证金',
          dataIndex: 'contractEarnest'
        },
        {
          title: '状态',
          dataIndex: 'status',
          scopedSlots: {
            customRender: 'status'
          }
        },
        {
          title: '操作',
          fixed: 'right',
          width: 80,
          scopedSlots: {
            customRender: 'operation'
          }
        }

      ],
      loading: false,
      tableData: [],
      page: {
        current: 1,
        size: 10,
        total: 0
      },
      companyId: ''
    }
  },
  created () {
    this.callback = () => { this.getTableData() }
    this.$bus.$on('ContractInfo:updateList', this.callback)
  },
  destroyed () {
    this.$bus.$off('ContractInfo:updateList', this.callback)
  },
  async mounted () {
    if (this.$route.params.id) {
      this.companyId = this.$route.params.id
    }
    this.getTableData()
  },

  methods: {
    async getTableData () {
      this.loading = true
      let { code, msg, data, page } = await investment.getContractInfoTable({
        companyId: this.companyId,
        ...this.page
      })
      this.loading = false
      if (code === 0) {
        this.tableData = data
        this.page.total = page.total
      } else {
        this.$message.error(msg || '数据获取失败')
      }
    },
    handleTableChange ({ current }) {
      this.page.current = current
      this.getTableData()
    }
  }
}
</script>

<style lang="less" scoped>
</style>
